module.exports = __webpack_public_path__ + "img/r3-ur3.d8ce5ab5.jpg";